<template>
  <div class="box">
    <div class="h_title">我的保障</div>
    <div class="profileList">
      <div class="profileList_item" v-for="item in list" :key="item.key" @click="toPath(item)">
        <div class="lable" style="color: #666666;">{{ item.lable }}</div>
        <div class="value">{{ profileData[item.key] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'my-contract',
  data() {
    return {
      list: [
        {
          lable: '未保障',
          key: 'unprotectedCount',
          path: '/electronicDocumentsList',
          query: { insuranceState: 0 }
        },
        {
          lable: '保障中',
          key: 'protectedCount',
          path: '/electronicDocumentsList',
          query: { insuranceState: 2 }
        },
        {
          lable: '部分退款',
          key: 'partialRefundCount',
          path: '/electronicDocumentsList',
          query: { insuranceState: 5 }
        },
        {
          lable: '全额退款',
          key: 'fullRefundCount',
          path: '/electronicDocumentsList',
          query: { insuranceState: 6}
        },
        {
          lable: '已到期',
          key: 'expiredCount',
          path: '/electronicDocumentsList',
          query: { insuranceState: 3}
        },
        {
          lable: '启动维权',
          key: 'insuranceInProcessCount',
          path: '/electronicDocumentsList',
          query: { insuranceState: 4 }
        }
      ]
    };
  },
  mounted() { },
  computed: {
    ...mapState({
      profileData: state => state.electronic.contractProfile
    }),
  },
  methods: {
    toPath(item) {
      this.$router.push({ path: item.path, query: item.query });
    }
  },
};
</script>

<style scoped lang="scss">
@use '../homeStyle.scss' as *;
.box {
  width: 100%;
  height: 130px;
  border-radius: $border-radius;
  background: $bg-j-1;
}
</style>